import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

export default function EfficiencyGauge({ data = [] }) {
  const theme = useTheme();

  const chartData = useMemo(() => {
    let totalEfficiency = 0;
    let count = 0;

    data.forEach(record => {
      if (record && typeof record.userSelectedTime === 'number' && 
          typeof record.actualChargingTime === 'number') {
        const efficiency = (record.userSelectedTime / record.actualChargingTime) * 100;
        if (efficiency > 0 && efficiency <= 150) { // Filter out outliers
          totalEfficiency += efficiency;
          count++;
        }
      }
    });

    const averageEfficiency = count > 0 ? Math.round(totalEfficiency / count) : 0;
    return [averageEfficiency];
  }, [data]);

  const options = {
    chart: {
      type: 'radialBar',
      background: 'transparent',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        hollow: {
          margin: 0,
          size: '70%',
          background: theme.palette.background.paper,
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24
          }
        },
        track: {
          background: theme.palette.grey[200],
          strokeWidth: '100%',
          dropShadow: {
            enabled: true,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35
          },
        },
        dataLabels: {
          name: {
            show: true,
            color: theme.palette.text.secondary,
            fontSize: '16px',
            offsetY: 5
          },
          value: {
            show: true,
            color: theme.palette.text.primary,
            fontSize: '24px',
            offsetY: -20,
            formatter: function (val) {
              return val + '%';
            }
          }
        }
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: [theme.palette.success.main],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    stroke: {
      dashArray: 4
    },
    labels: ['Charging Efficiency'],
    colors: [theme.palette.primary.main]
  };

  return (
    <ReactApexChart
      options={options}
      series={chartData}
      type="radialBar"
      height={350}
    />
  );
}